<template>
  <div class="posts-search">
    <div class="posts-search__form">
      <div class="filters-container">
        <p class="label">Filter:</p>
        <ul class="filter">
          <li>
            <div class="select-container">
              <select
                id="groups"
                name="groups"
                data-size="5"
                class="select-filter"
                v-model="this.selectedGroups"
                @change="filterPostsbyGroup()"
              >
                <option value="0">All</option>
                <option
                  v-for="group in groups"
                  :key="group.id"
                  :value="group.id"
                >
                  {{ group.name }}
                </option>
              </select>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div v-if="total == 0 && !loading" class="posts-search__no-results">
      Sorry, there are no team members that match the above criteria.
    </div>

    <TransitionGroup
      name="stagged-fade"
      tag="div"
      class="posts-search__results posts-search__results--team"
    >
      <template v-for="(post, index) in posts" :key="index">
        <div class="posts-search__post">
          <div class="team-item-container">
            <a :href="post.customFields.link">
              <div class="image-container">
                <img
                  :src="post.customFields.featured_image_src"
                  :srcset="post.customFields.featured_image_srcset"
                  sizes="(max-width: 480px) 100vw, 50vw"
                  :alt="post.customFields.featured_image_alt"
                  loading="lazy"
                />

                <div class="view-profile">
                  <div class="button">View profile</div>
                </div>
              </div>
            </a>

            <div class="content-container">
              <a :href="post.customFields.link">
                <h3 class="card-title">{{ post.title }}</h3></a
              >
              <p class="category" v-html="post.customFields.job_title"></p>
            </div>
          </div>
        </div>
      </template>
    </TransitionGroup>

    <div v-if="loading" class="posts-search__loading-spinner"></div>

    <div v-if="!loading && showMore" class="posts-search__load-more">
      <div @click="getMorePosts" class="button">Load more</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {},
  data() {
    return {
      posts: [],
      groups: [],
      params: {
        page: 1,
        per_page: 100,
        orderby: "menu_order",
        order: "asc",
        companies: 0,
        years: 0,
      },
      keywords: "",
      selectedGroups: "0",
      loading: false,
      total: 10,
      totalPages: 0,
      staggerDelay: 50,
    };
  },
  mounted() {
    // Store team category to localstorage
    const teamFilter = localStorage.getItem("selectedGroupFilter");
    if (teamFilter !== null) {
      this.selectedGroups = teamFilter;
      if (teamFilter !== "0") {
        this.params.team_groups = teamFilter;
      }
    }

    if (this.config.defaultCategoryID) {
      this.selectedGroups = this.config.defaultCategoryID;
      this.params.team_groups = this.config.defaultCategoryID;
    }
    this.getGroups();
    this.getPosts();
  },
  computed: {
    showMore() {
      return this.params.page < this.totalPages || this.loading;
    },
  },
  methods: {
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    async getGroups() {
      this.loading = true;

      await this.axios
        .get("team_groups", { perPage: -1, hide_empty: true })
        .then((response) => {
          this.groups = response.data;
        });

      this.loading = false;
    },

    async getPosts() {
      this.loading = true;

      const params = { ...this.params };

      await this.axios
        .get("team", {
          params,
        })
        .then((response) => {
          const posts = [];

          response.data.forEach((post) => {
            posts.push({
              link: post.link,
              title: post.title.rendered,
              excerpt: post.excerpt.rendered,
              date: post.formatted_date,
              customFields: post.custom_fields,
            });
          });
          this.posts = this.posts.concat(posts);
          this.total = parseInt(response.headers["x-wp-total"], 10);
          this.totalPages = parseInt(response.headers["x-wp-totalpages"], 10);
        });

      this.loading = false;
    },
    async getMorePosts() {
      this.params.page += 1;
      this.loading = true;

      const params = { ...this.params };

      await this.axios
        .get("team", {
          params,
        })
        .then((response) => {
          const morePosts = [];

          response.data.forEach((post) => {
            morePosts.push({
              link: post.link,
              title: post.title.rendered,
              excerpt: post.excerpt.rendered,
              date: post.formatted_date,
              customFields: post.custom_fields,
            });
          });
          this.posts = this.posts.concat(morePosts);
        });

      this.loading = false;
    },
    filterPosts() {
      this.posts = [];
      this.params.page = 1;
      this.getPosts();
    },
    filterPostsbyGroup() {
      localStorage.setItem("selectedGroupFilter", this.selectedGroups);

      this.posts = [];
      this.params.page = 1;

      if (this.selectedGroups !== 0 && this.selectedGroups !== "0") {
        this.params.team_groups = this.selectedGroups;
      } else {
        delete this.params.team_groups;
      }

      this.getPosts();
    },
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    onEnter(el) {
      const delay = el.dataset.index * this.staggerDelay;
      setTimeout(() => {
        el.style.opacity = 1;
      }, delay);
    },
    onLeave(el) {
      el.style.display = "none";
    },
    paginationCallback(pageNumber) {
      this.params.page = pageNumber;
      // history.pushState(
      //   this.params.page,
      //   'null',
      //   window.location.pathname + '?pl=' + this.params.page,
      // );

      // // Jump to search results.
      // let top = document.getElementById('results-top').offsetTop;
      // window.scrollTo(0, top - 300);

      this.filterPaginationPosts();
    },
  },
};
</script>
